import AbacusClasses from '../../abacus/abacus-classes/abacus-classes';
import ActivityIndicator, {HA_PULSE_ACTIVITY_INDICATORS} from '../activity-indicator/activity-indicator';
import classNames from 'classnames';
import {compose} from 'redux';
import edap from '../edap';
import Permissions from '../../components/permissions';
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {Redirect} from 'react-router';
import {ROLES} from '../../utils/constants';
import routes from '../../routes';
import ThreePack from './three-pack';
import withAbacusTestValuesAsProps from '../../abacus/with-abacus-test-values-as-props';
import {withTranslationsAsProps} from '../../components/translations';
import {WATERFALL_AB} from '../../abacus/experiments';
import {SVGIcon} from '@homeaway/react-svg';
import {TRASHCAN__16} from '@homeaway/svg-defs/lib/defs/TRASHCAN__16';
import {Button} from '@homeaway/react-buttons';

import './tripboard-card.less';

// Abacus: HA_PULSE_SKELETON_ABC
import {SkeletonHidden, SkeletonLoading} from '../../abacus/skeleton-abc';

// Abacus: waterfall
import {LazyImagePack} from '../../abacus/waterfall';

// export base presentational Component
export class TripboardCard extends Component {
    static propTypes = {
        boardId: PropTypes.string,
        count: PropTypes.number,
        index: PropTypes.number,
        name: PropTypes.string,
        role: PropTypes.string,
        total: PropTypes.number,
        onDelete: PropTypes.func,
        image1: PropTypes.string,
        image2: PropTypes.string,
        image3: PropTypes.string
    }

    static defaultProps = {
        count: 0,
        index: 0,
        role: ROLES.OWNER,
        total: 0,
        waterfallTestValue: 0
    };

    constructor(props) {
        super(props);

        this.state = {
            isPendingDeletion: false,
            shouldRedirect: false
        };
    }

    handleClick = () => {
        const {boardId, index, total} = this.props;
        if (this.isDisabled() || this.state.isPendingDeletion) {
            return;
        }
        edap.boardClick(boardId, index, total);
        this.setState({shouldRedirect: true});
    }

    markDelete = (e) => {
        const {boardId} = this.props;
        e.stopPropagation();
        if (!this.isDisabled()) {
            this.setState({isPendingDeletion: true});
            edap.deleteStart(boardId);
        }
    }

    confirmDelete = () => {
        const {onDelete, boardId} = this.props;
        onDelete(boardId);
        edap.deleteAttempt(this.props.boardId);
    }

    cancelDelete = () => {
        this.setState({isPendingDeletion: false});
        edap.deleteCancel(this.props.boardId);
    }

    // Abacus: skeleton test
    isDisabled = () => {
        const {boardId, isLoading} = this.props;
        return !boardId || isLoading || false;
    }

    renderCardPack = () => {
        const {
            image1,
            image2,
            image3,
            isLoading,
            isLazyLoad,
            waterfallTestValue
        } = this.props;

        const isWaterFallTestOn = waterfallTestValue > 0;

        // Abacus: waterfall
        if (isWaterFallTestOn) {
            return (
                <LazyImagePack
                    image1={image1}
                    image2={image2}
                    image3={image3}
                    isLazyLoad={isLazyLoad}
                    isThreePack
                />
            );
        }

        return (
            <ThreePack
                image1={image1}
                image2={image2}
                image3={image3}
                isLoading={isLoading} // Abacus: skeleton abc
            />
        );
    }

    render() {
        const {isPendingDeletion, shouldRedirect} = this.state;
        let {
            boardId,
            count,
            isLoading,
            langCancel,
            langDeleteConfirmation,
            langYesDelete,
            langDeleteNoUndo,
            langRemoveConfirmation,
            langRemoveNoUndo,
            langYesRemove,
            name,
            role
        } = this.props;

        if (shouldRedirect) {
            return (
                <Redirect
                    push
                    to={{
                        pathname: routes.TRIPBOARD_DETAILS.replace(':boardId', boardId),
                        state: {referrer: routes.TRIPBOARD}
                    }}
                />
            );
        }

        const tripboardSummaryHitClass = (isPendingDeletion)
            ? 'tripboard-summary-hit__inner is-blurred'
            : 'tripboard-summary-hit__inner';

        const cardClass = classNames({
            'tripboard-summary-hit': true,
            'card': true,
            'is-disabled': this.isDisabled()
        });

        const cardPack = this.renderCardPack();

        return (
            <AbacusClasses testNames={[HA_PULSE_ACTIVITY_INDICATORS]}>
                <div className="tripboard-summary-container__hit-wrapper">
                    <div
                        className={cardClass}
                        data-wdio="tripboard-summary__hit-button"
                        onClick={this.handleClick}
                        onKeyPress={this.handleClick}
                        role="button"
                        tabIndex="0"
                    >
                        <div className={tripboardSummaryHitClass}>
                            <div className="tripboard-summary-hit__top-bar">
                                {/* Abacus: skeleton abc */}
                                <SkeletonLoading loading={isLoading}>
                                    <h3
                                        className="tripboard-summary-hit__name"
                                        data-wdio="tripboard-summary__hit-name"
                                    >
                                        {name}
                                    </h3>
                                </SkeletonLoading>
                                {boardId &&
                                    <ActivityIndicator boardId={boardId} />
                                }
                                <SkeletonHidden loading={isLoading}>
                                    <span className="tripboard-summary-hit__listings">
                                        <svg className="tripboard-summary-hit__heart svg-black inline-svg">
                                            <path d="M14.1294135,7.57785915 L9.1813451,12.5257519 C8.40187017,13.3051991 7.13698698,13.3040721 6.35866678,12.5257519 L1.41077405,7.57785915 C0.543404248,6.78002342 -8.8817842e-16,5.63564613 -8.8817842e-16,4.3646175 C-8.8817842e-16,1.9541783 1.95395254,0 4.3646175,0 C5.60449125,0 6.72403494,0.517216091 7.51825852,1.3473355 C7.60675643,1.43944557 7.69073914,1.53539356 7.76998089,1.63472794 C7.84989992,1.53539356 7.93365686,1.43944557 8.02170325,1.3473355 C8.81615259,0.517216091 9.93569628,0 11.1753443,0 C13.5860092,8.02060533e-16 15.5399618,1.9541783 15.5399618,4.3646175 C15.5399618,5.63564613 14.9965575,6.78024918 14.1294135,7.57785915 Z"/>
                                        </svg>
                                        <small className="tripboard-summary-hit__count" data-wdio="tripboard-summary__hit-count">{count}</small>
                                    </span>
                                </SkeletonHidden>
                            </div>
                            {cardPack}
                            <div className="tripboard-summary-hit__bottom-bar">
                                <SkeletonLoading loading={isLoading}>
                                    <Button
                                        aria-label={(role === ROLES.COLLABORATOR) ? langRemoveConfirmation : langDeleteConfirmation}
                                        className="btn btn-link tripboard-summary-hit__btn-trashcan"
                                        onClick={this.markDelete}
                                        label={
                                            <React.Fragment>
                                                <SkeletonHidden loading={isLoading}>
                                                    <SVGIcon inlineFlex markup={TRASHCAN__16}/>
                                                </SkeletonHidden>
                                            </React.Fragment>
                                            }
                                    />
                                </SkeletonLoading>
                            </div>
                        </div>
                        { isPendingDeletion &&
                            <div className="tripboard-summary-prompt">
                                <div className="tripboard-summary-prompt__content">
                                    <Permissions role={role} inverse collaborator>
                                        <p className="tripboard-summary-prompt__copy">{`${langDeleteConfirmation} ${langDeleteNoUndo}.`}</p>
                                        <button className="tripboard-summary-prompt__delete-btn btn btn-sm btn-overlay" onClick={this.confirmDelete} data-wdio="tripboard-summary__hit-delete--confirm">{langYesDelete}</button>
                                    </Permissions>
                                    <Permissions role={role} collaborator>
                                        <p className="tripboard-summary-prompt__copy">{`${langRemoveConfirmation} ${langRemoveNoUndo}.`}</p>
                                        <button className="tripboard-summary-prompt__delete-btn btn btn-sm btn-overlay" onClick={this.confirmDelete} data-wdio="tripboard-summary__hit-delete--confirm">{langYesRemove}</button>
                                    </Permissions>
                                    <button className="tripboard-summary-prompt__cancel-btn btn btn-sm btn-overlay" onClick={this.cancelDelete} data-wdio="tripboard-summary__hit-delete--cancel">{langCancel}</button>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </AbacusClasses>
        );
    }
}

// export wired component as default
export default compose(
    withAbacusTestValuesAsProps({
        [WATERFALL_AB]: 'waterfallTestValue'
    }),
    withTranslationsAsProps({
        'tripboards.cancel': 'langCancel',
        'tripboards.main.delete.confirmation': 'langDeleteConfirmation',
        'tripboards.main.yes.delete': 'langYesDelete',
        'tripboards.main.delete.cant.undo': 'langDeleteNoUndo',
        'tripboards.main.remove.confirmation': 'langRemoveConfirmation',
        'tripboards.main.remove.cant.undo': 'langRemoveNoUndo',
        'tripboards.main.yes.remove': 'langYesRemove'
    })
)(TripboardCard);



// WEBPACK FOOTER //
// ./src/universal/tripboard/components/tripboard-card.js